//
import { uploadUrl, pdaUpLoad } from '../api';
import { Message } from 'element-ui';
const pda = {
  namespaced: true,
  state: {
    resp: {},
    total: null,
    uploadUrl,
    pdaUpLoadResp:null
  },
  mutations: {
    QUERY_LIST(state, resp) {
      state.resp = resp.obj || {};
    },
    PDA_DATA(state, data) {
      state.pdaUpLoadResp = data;
    },
  },
  actions: {
    async queryListInfo({ commit }, obj) {
      let resp = await queryList(obj);
      commit('QUERY_LIST', resp);
    },
    //导入数据
    async pdaUpLoad({ commit }, obj) {
      let resp = await pdaUpLoad(obj);
      commit('PDA_DATA', resp);
    },
  },
}

export default pda



// WEBPACK FOOTER //
// ./src/page/sm/pda/store/pda.store.js